import React from 'react';
import { useNavigate } from 'react-router-dom';
import RegisterForm from '../components/RegisterForm';

const RegisterPage: React.FC = () => {
  const navigate = useNavigate();

  const handleRegisterSuccess = () => {
    console.log('RegisterPage: 회원가입 성공, 로그인 페이지로 이동');
    navigate('/login');
  };

  const handleSwitchToLogin = () => {
    navigate('/login');
  };

  return (
    <RegisterForm 
      onSuccess={handleRegisterSuccess}
      onSwitchToLogin={handleSwitchToLogin}
    />
  );
};

export default RegisterPage;


